import React from "react";
import IsolationPermitStepPage from "./IsolationPermitStepPage";

function RequestIsolation(props) {
  return <IsolationPermitStepPage {...props} step="request" />;
}

export default RequestIsolation;
